import React, { FC, memo } from 'react';
import { Stack } from '@mui/material';
import { Button } from 'Components/Core/Button';
import { ButtonSize, ButtonVariant } from 'Components/Core/Button/types';
import { HbtIcon } from 'Components/Core/HbtIcon';
import { HbtIconSize } from 'Components/Core/HbtIcon/types';
import { DataTableFilterButtonProps } from './types';

export const DataTableFilterButton: FC<DataTableFilterButtonProps> = memo(
  ({ isShown, name, text, ariaText, onClick }) =>
    isShown ? (
      <Stack direction="row" justifyContent="flex-end">
        <Button
          name={name}
          size={ButtonSize.SMALL}
          variant={ButtonVariant.SECONDARY}
          onClick={onClick}
          text={{ value: text }}
          ariaText={{ value: ariaText }}
          leadingIcon={() => <HbtIcon size={HbtIconSize.SMALL} type="icon_filter" />}
        />
      </Stack>
    ) : null
);
